module.exports = __webpack_public_path__ + "static/media/edit_icon_blue.5e58af42.png";